import React from 'react';
import { Smile, Meh, Frown } from 'lucide-react';

interface ScoreBadgeProps {
  score: number | string;
  maxScore?: number;
  className?: string;
}

// Define cores para diferentes faixas de nota
const getScoreColors = (score: number) => {
  if (score >= 80) {
    return {
      text: 'text-green-700',
      background: 'bg-green-100',
      border: 'border-green-200',
      Icon: Smile,
      label: 'Satisfatório',
    };
  } else if (score >= 50) {
    return {
      text: 'text-yellow-700',
      background: 'bg-yellow-100',
      border: 'border-yellow-200',
      Icon: Meh,
      label: 'Atenção',
    };
  } else {
    return {
      text: 'text-red-700',
      background: 'bg-red-100',
      border: 'border-red-200',
      Icon: Frown,
      label: 'Crítico',
    };
  }
};

const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, maxScore = 100, className = '' }) => {
  const { text, background, border, Icon, label } = getScoreColors(Number(score));

  return (
    <div
      className={`inline-flex items-center gap-2 sm:gap-3 justify-center rounded-full border-2 ${text} ${background} ${border} ${className} px-3 py-1 sm:px-4 sm:py-2`}
      title={`Nota de análise prévia: ${score}/${maxScore}`}
    >
      <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
      <div className="flex flex-col items-center leading-none">
        <span className="text-sm sm:text-base font-bold">
          {score}/{maxScore}
        </span>
        <span className="text-[10px] sm:text-xs font-medium">{label}</span>
      </div>
    </div>
  );
};

export default ScoreBadge;
